export default __webpack_public_path__ + "static/media/user_badge_2.e4cd1401.svg";